module.exports = __webpack_public_path__ + "assets/images/0c08fbaf35dc50aebb592aca25a47cd3.png";